import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FarmerDetails } from '../models/farmer-details.model';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root'
})
export class FarmersDetailsService extends BaseService {

  constructor(private _http: HttpClient, tokenService: TokenService) {
    super(tokenService);
    this._http = _http;
  }

  postFarmersData(data: FarmerDetails): Observable<any> {
    return this._http.post(environment.apiUrl + 'PersonalDetails/Insert', data)
  }
  updateFarmersData(data: FarmerDetails): Observable<any> {
    return this._http.post(environment.apiUrl + 'PersonalDetails/Update', data)
  }
  getVillageMatserData(): Observable<any> {
    if(window.localStorage.getItem("villageMaster")){
      return of(JSON.parse(window.localStorage.getItem("villageMaster")));
    }else{
      return this._http.get(environment.apiUrl + 'PersonalDetails/VillageMaster')
    }
  }
  getCasteMatserData(): Observable<any> {
    return this._http.get(environment.apiUrl + 'PersonalDetails/CastMaster')
  }

  getFarmerDetails(phoneNo): Observable<any> {
    // return this._http.get<any>(`${environment.apiUrl}PersonalDetails/GetDataByMobileNo?MobileNo=${phoneNo}`, { headers: this.buildHeaders() });
    return this._http.get<any>(`${environment.apiUrl}PersonalDetails/GetDataByMobileNo?MobileNo=${phoneNo}`);

  }

  uploadFile(data, mobile, uploadType){
    return this._http.post(`${environment.apiUrl}File/Upload?MobileNo=${mobile}&UploadType=${uploadType}`, data,
    // {
    //   headers: {
    //     'Content-Type': 'multipart/form-data',
    //   },
    // }
    )
  }
  getBase64Image(path){
    return this._http.get(`${environment.apiUrl}File/GetFileAsBase64/${path}`)
  }

  getTargetStatus(reqBody){
     return this._http.post<any>(`${environment.apiUrl}FarmerApplication/GetTargetStatus?AppId=${reqBody.AppId}&VillageCode=${reqBody.VillageCode}&MI=${reqBody.MI}&Pond=${reqBody.Pond}&Solar=${reqBody.Solar}&LandId=${reqBody.LandId}&ProgramId=${reqBody.ProgramId}&ApplyArea=${reqBody.ApplyArea}`, {responseType: 'text'})
  }

  getVillageBasedOnFarmerId(farmerId): Observable<any> {
    return this._http.get<any>(`${environment.apiUrl}FarmerApplication/GetVillageBasedOnFarmerId?FarmerId=${farmerId}`);

  }

}
